import React, { Component } from "react";
import styles from "../SlideCompositionPage.local.scss";
import _ from "i18n";
import { connect } from "react-redux";
import { Switch } from "antd";

class AddIndicatorsExplanation extends Component {
  render() {
    const { ComponentConfig, isBarometerConfig, isTableConfig } = this.props;
    return (
      <div>
        <div className={styles.actions_block}>
          <div
            style={{
              display: "inline-flex",
              width: "100%"
            }}
          >
            <span className={styles.explanation_title}>
              {_("addExplanation")}
            </span>
            <div
              className="switch-container"
              style={{ display: "inherit", marginTop: "2%" }}
            >
              <Switch
                className={styles.switch}
                checked={
                  ComponentConfig.config.hasExplanation !== undefined &&
                  ComponentConfig.config.hasExplanation === true
                }
                onChange={() =>
                  this.props.handlerIndicatorsExplanation(
                    isBarometerConfig,
                    isTableConfig
                  )
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  ComponentConfig: state.slideComposition.componentConfig
});

export default connect(mapStateToProps)(AddIndicatorsExplanation);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/ComponentConfiguration/AddIndicatorsExplanation.js